import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Modal } from 'react-bootstrap';
import axios from 'axios';
//Components 
import Navbar from '../NavBar/Navbar';
//API 
import { ClientsFetchAPI } from '../../api/Clients';


// Dashboard for managing frequent shopper clients, their points, and transactions
const Clients = () => {
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [clientTransactions, setClientTransactions] = useState([]);
    let token = localStorage.getItem('x-access-token');
    let user = JSON.parse(localStorage.getItem('user'))


    // Load config
    useEffect(() => {
        getBusinessClients()
    }, []);

    //Function to get the clients of a business
    const getBusinessClients = async () => {
        try {
            const res = await ClientsFetchAPI.getClientsByBusiness(user.business.id, token);
            setClients(res.data.data);
        } catch (error) {
            setClients([]);
        }
    }

    //Function to get the transactions of a client
    const handleClientDetails = (client) => {
        setSelectedClient(client);
        getClientPointsTransactions(client.id);
        setShowModal(true);
    };


    //Function to get the transaction points of a client
    const getClientPointsTransactions = async (clientId) => {
        try {
            const res = await ClientsFetchAPI.getFrecuentShopperPointsTransactions(clientId, token);
            setClientTransactions(res.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))); // Sort by date descending
        } catch (error) {
            setClientTransactions([]);
        }
    };
    return (
        <>
            <Navbar titlePage="Clients"  route="new_clients"/>
            <div className='bg-light pt-4'>
                <div className='container'>

                    {/* Main content starts here */}
                    <main>
                        <h2 className="my-4">Clientes</h2>

                        <Row>
                            <Col md={12}>
                                <Card className="mb-4">
                                    <Card.Body>
                                        <Card.Title>Clientes Registrados</Card.Title>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Nombre de usuario</th>
                                                    <th>Email</th>
                                                    <th>Puntos</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {clients.map(client => (
                                                    <tr key={client.id}>
                                                        <td>{client.name}</td>
                                                        <td>{client.nickname}</td>
                                                        <td>{client.email}</td>
                                                        <td>{client.points}</td>
                                                        <td>
                                                            <Button variant="info" size="sm" onClick={() => handleClientDetails(client)}>
                                                                Ver Detalles
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>Historial de Puntos - {selectedClient?.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Tipo</th>
                                            <th>Descripción</th>
                                            <th>Puntos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {clientTransactions.map(tx => (
                                            <tr key={tx.id}>
                                                <td>{new Date(tx.createdAt).toLocaleString()}</td>
                                                <td>{tx.type}</td>
                                                <td>{tx.description}</td>
                                                <td>{tx.points}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Modal.Body>
                        </Modal>
                    </main>

                </div>
            </div>
        </>
    );
};

export default Clients;
